// Module
var code = `<app-tree-view-node *ngFor="let itemData of this.data" [data]="itemData" [template]="this.nodeTemplate"> </app-tree-view-node> `;
// Exports
export default code;